import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import axios from 'axios';

class Logout extends Component {
   constructor(props){
      super(props);
      this.state = {
         logout: false
      }
   }
   componentDidMount(){
      axios.get(process.env.REACT_APP_API_HOST + '/logout')
      .then(res => {
         localStorage.removeItem('userData');
      })
   }
   componentWillMount(){
      Promise.all([localStorage.removeItem('userData')]).then(() => {
         this.setState({
            logout: true
         })
      })
   }
   
   render() {
      if(this.state.logout){
         return (
            <Redirect to={'/?ref=logout'}/>
            )
         }else{
            return(
               <div>Logging Out..</div>
               )
            }
         }
      }
      
      export default Logout;
      